// extracted by mini-css-extract-plugin
export default {"controls":"K3xPw5prBDSlIZQsN1yiIA==","backButton":"_2cqoadduFuKFSlnaOnVWyQ=="};